import { render, staticRenderFns } from "./AssetTypeSetup.vue?vue&type=template&id=4ab4724d&scoped=true"
import script from "./AssetTypeSetup.vue?vue&type=script&lang=ts"
export * from "./AssetTypeSetup.vue?vue&type=script&lang=ts"
import style0 from "./AssetTypeSetup.vue?vue&type=style&index=0&id=4ab4724d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4724d",
  null
  
)

export default component.exports